import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Plus, ScrollText, Paperclip } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { useFetch } from "@/hooks/useFetch";
import { fmtDate } from "@/lib/format";
import { Card, Empty, PageHeader, Spinner } from "@/components/Field";
import { StatusBadge } from "@/components/StatusBadge";
import { MinuteDialog, MINUTE_KINDS } from "@/components/dialogs/MinuteDialog";

export default function MinutesPage() {
  const { can } = useAuth();
  const nav = useNavigate();
  const { data, reload } = useFetch("/minutes");
  const [open, setOpen] = useState(false);
  return (
    <>
      <PageHeader title="Verbali" subtitle="Verbali delle assemblee e del comitato, sempre consultabili">
        {can("minutes", "create") && <Button data-testid="minutes-new" className="h-11" onClick={() => setOpen(true)}><Plus className="h-4 w-4 mr-1" /> Nuovo verbale</Button>}
      </PageHeader>
      {!data ? <Spinner /> : data.length === 0 ? <Empty text="Nessun verbale ancora." testId="minutes-empty" /> : (
        <Card testId="minutes-list">
          <ul className="divide-y">
            {data.map((m) => (
              <li key={m.id}>
                <button data-testid={`minute-row-${m.id}`} onClick={() => nav(`/verbali/${m.id}`)} className="w-full flex items-center gap-4 px-5 py-4 text-left hover:bg-slate-50">
                  <ScrollText className="h-5 w-5 text-primary shrink-0" />
                  <div className="min-w-0 flex-1">
                    <div className="font-semibold text-slate-900 truncate">{m.title}</div>
                    <div className="text-sm text-slate-500">{fmtDate(m.date)}{m.location && ` · ${m.location}`}</div>
                  </div>
                  {m.files?.length > 0 && <span className="inline-flex items-center gap-1 text-sm text-slate-500"><Paperclip className="h-4 w-4" />{m.files.length}</span>}
                  <StatusBadge label={MINUTE_KINDS[m.kind]} />
                </button>
              </li>
            ))}
          </ul>
        </Card>
      )}
      <MinuteDialog open={open} onOpenChange={setOpen} onSaved={(d) => { reload(); nav(`/verbali/${d.id}`); }} />
    </>
  );
}
